import * as React from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker, TimePickerProps } from '@mui/x-date-pickers/TimePicker';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { DateTime } from 'luxon';

type IbssTimePickerProps = TimePickerProps<DateTime>;
class IbssTimePicker extends React.Component<IbssTimePickerProps> {

  constructor(props: IbssTimePickerProps) {
    super(props);
  };

  render(): React.ReactNode {
    const { slotProps, ...restProps } = this.props as IbssTimePickerProps;
    return (
      <LocalizationProvider dateAdapter={AdapterLuxon}>
        <TimePicker
          {...restProps}
          ampm={false}
          desktopModeMediaQuery='@media (min-width: 720px)'
          slotProps={{
            ...slotProps,
            popper: {
              sx: {
                '& .MuiMultiSectionDigitalClockSection-root': {
                  minWidth: '75px',
                },
              },
            },
          }}
        />
      </LocalizationProvider>
    );
  }
};

export default IbssTimePicker;